import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { FaFilePdf } from 'react-icons/fa'; // Importa o ícone de PDF
import Modal from 'react-modal'; // Importa o Modal
import Navbar from '../../../components/Navbar';
import Background from '../../../components/Background';
import Container from '../../../components/Container';
import Header from '../../../components/Header';
import style from './InserirDocs.module.css';


// Defina o estilo do modal
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',  // Ajusta a largura do modal para caber na tela
    height: '90%', // Ajusta a altura do modal para caber na tela
    overflow: 'hidden', // Remove o scroll do modal
  }
};

Modal.setAppElement('#root'); // Defina o elemento principal do seu app para acessibilidade

const InserirDocs = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [documentos, setDocumentos] = useState([]);
  const [filteredDocs, setFilteredDocs] = useState([]); // Novo estado para armazenar documentos filtrados
  const [navios, setNavios] = useState([]); // Estado para armazenar os navios únicos
  const [selectedNavio, setSelectedNavio] = useState(""); // Estado para o filtro de navio
  const [selectedPeriodo, setSelectedPeriodo] = useState(""); // Estado para o filtro de período
  const [isOpen, setIsOpen] = useState(false); // Estado para controlar o modal
  const [selectedPdf, setSelectedPdf] = useState(null); // Estado para armazenar o PDF selecionado

  useEffect(() => {
    // Faz a requisição para a rota "/api/dds/segtrabalho" e obtém os dados
    axios.get('https://operacao.setlogistica.com.br/api/dds/segtrabalho')
      .then(response => {
        const documentos = response.data;
        setDocumentos(documentos);
        setFilteredDocs(documentos); // Inicializa a lista filtrada com todos os documentos

        // Pega navios únicos para o filtro
        const uniqueNavios = [...new Set(documentos.map(doc => doc.NOME_NAVIO))];
        setNavios(uniqueNavios);
      })
      .catch(error => {
        console.error("Erro ao buscar documentos:", error);
        enqueueSnackbar('Erro ao carregar documentos', { variant: 'error' });
      });
  }, [enqueueSnackbar]);

  // Função para aplicar o filtro sempre que os estados forem alterados
  useEffect(() => {
    const filtered = documentos.filter(doc => {
      const navioMatch = selectedNavio === "" || doc.NOME_NAVIO === selectedNavio;

      // Extrai apenas o período (a parte após a data)
      const periodoNoDoc = doc.PERIODO_CARREGAMENTO.split(' ')[1]; 

      const periodoMatch = selectedPeriodo === "" || periodoNoDoc === selectedPeriodo;
      return navioMatch && periodoMatch;
    });
    setFilteredDocs(filtered);
  }, [selectedNavio, selectedPeriodo, documentos]);

  // Manipuladores de mudança de filtro
  const handleNavioChange = (e) => {
    setSelectedNavio(e.target.value);
  };

  const handlePeriodoChange = (e) => {
    const periodoSelecionado = e.target.value;
    setSelectedPeriodo(periodoSelecionado);
  };

  // Função para abrir o modal com o PDF gerando o caminho correto
  const openModal = (idDocumento) => {
    const pdfUrl = `https://operacao.setlogistica.com.br/api/documentos/dds/${idDocumento}.pdf`; // Gera o caminho correto
    setSelectedPdf(pdfUrl);
    setIsOpen(true);
  };

  // Função para fechar o modal
  const closeModal = () => {
    setIsOpen(false);
    setSelectedPdf(null);
  };

  return (
    <>
      <Navbar motivados />
      <Header />
      <Background />
      <Container>
        <div className={style.content}>
          <div className={style.nav}>
            <div onClick={() => navigate("")}>
              SEGURANÇA DO TRABALHO
            </div>
          </div>

          {/* Filtros */}
          <div className={style.filterContainer}>
            <div className={style.filterColumn}>
              <label htmlFor="navioFilter">Filtrar por Navio:</label>
              <select
                id="navioFilter"
                name="navio"
                value={selectedNavio}
                onChange={handleNavioChange}
              >
                <option value="">Todos</option>
                {navios.map((navio, index) => (
                  <option key={index} value={navio}>{navio}</option>
                ))}
              </select>
            </div>

            <div className={style.filterColumn}>
              <label htmlFor="periodoFilter">Filtrar por Período:</label>
              <select
                id="periodoFilter"
                name="periodo"
                value={selectedPeriodo}
                onChange={handlePeriodoChange}
              >
                <option value="">Todos</option>
                <option value="01h⁰⁰/07h⁰⁰">01h⁰⁰/07h⁰⁰</option>
                <option value="07h⁰⁰/13h⁰⁰">07h⁰⁰/13h⁰⁰</option>
                <option value="13h⁰⁰/19h⁰⁰">13h⁰⁰/19h⁰⁰</option>
                <option value="19h⁰⁰/01h⁰⁰">19h⁰⁰/01h⁰⁰</option>
              </select>
            </div>
          </div>

          <div className={style.table}>
            <div className={style.table_outer_container}>
              <div className={style.table_container}>
                <table className={style.custom_table}>
                  <thead>
                    <tr>
                      <th>Tipo</th>
                      <th>Nome Navio</th>
                      <th>Data</th>
                      <th>Período</th>
                      <th>Usuário</th>
                      <th>PDF</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredDocs.map((doc) => (
                      <tr key={doc.ID_DOCUMENTO}>
                        <td>{doc.NOME_DOCUMENTO}</td>
                        <td>{doc.NOME_NAVIO}</td>
                        <td>{new Date(doc.DATA_DOCUMENTO).toLocaleDateString()}</td>
                        <td>{doc.PERIODO_CARREGAMENTO}</td>
                        <td>{doc.USUARIO_DOCUMENTO}</td>
                        <td>
                          <FaFilePdf
                            size={24}
                            color="red"
                            onClick={() => openModal(doc.ID_DOCUMENTO)} // Abre o modal ao clicar no ícone
                            style={{ cursor: 'pointer' }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Modal para exibir o PDF */}
        <Modal
          isOpen={isOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Exibir PDF"
        >
          {selectedPdf && (
            <embed
              src={selectedPdf}
              type="application/pdf"
              width="100%"
              height="100%"
              style={{ border: 'none' }}  // Remove a borda do embed
            />
          )}
        </Modal>

      </Container>
    </>
  );
};

export default function IntegrationNotistack() {
  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      maxSnack={3}
      autoHideDuration={2500}
    >
      <InserirDocs />
    </SnackbarProvider>
  );
}
